import { render, staticRenderFns } from "./HomeCategorySlide.vue?vue&type=template&id=a19fcf6c&scoped=true&"
import script from "./HomeCategorySlide.vue?vue&type=script&lang=js&"
export * from "./HomeCategorySlide.vue?vue&type=script&lang=js&"
import style0 from "./HomeCategorySlide.vue?vue&type=style&index=0&id=a19fcf6c&lang=scss&scoped=true&"
import style1 from "./HomeCategorySlide.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19fcf6c",
  null
  
)

export default component.exports